<div id="notifications" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">Circular and Notices</h1>
    <p class="inner-lead mt-3">
      Stay informed with the latest circulars and notices issued by Shah Satnam Ji Girls' College. All official announcements, exam schedules, and important updates are posted here.
    </p>

    <hr class="divider">

    <div class="table-responsive mt-4">
      <table class="table table-bordered table-hover">
        <thead class="table-header">
          <tr>
            <th style="width: 150px;">Date</th>
            <th>Circular / Notice Title</th>
            <th style="width: 150px;">Action</th>
          </tr>
        </thead>
        <tbody>
          <!-- Dynamic CMS Notices -->
          <tr *ngFor="let item of cmsNotices">
            <td class="text-muted">{{ item.dateStr }}</td>
            <td>
              <strong>{{ item.title }}</strong>
              <div *ngIf="item.showDetails" class="text-muted small mt-2 p-2 border rounded bg-light" style="font-size: 13px; line-height: 1.45;">
                <span *ngIf="item.description">{{ item.description }}</span>
                <span *ngIf="!item.description"><em>No description provided</em></span>
              </div>
            </td>
            <td>
              <a href="javascript:void(0)" (click)="toggleDetails(item)" class="text-primary fw-bold text-decoration-none me-3">
                {{ item.showDetails ? 'Hide Details' : 'View Details' }} <i class="fa fa-info-circle small" [class.fa-chevron-up]="item.showDetails" [class.fa-chevron-down]="!item.showDetails"></i>
              </a>
              <a *ngIf="item.pdfUrl" [href]="item.pdfUrl" target="_blank" class="text-primary fw-bold text-decoration-none me-3">
                View PDF <i class="fa fa-external-link small"></i>
              </a>
              <a *ngIf="item.imageUrl" [href]="item.imageUrl" target="_blank" class="text-primary fw-bold text-decoration-none">
                View Image <i class="fa fa-external-link small"></i>
              </a>
              <span *ngIf="!item.pdfUrl && !item.imageUrl && !item.description" class="text-muted small">No attachments</span>
            </td>
          </tr>

          <!-- Hardcoded Notices -->
          <tr>
            <td class="text-muted">May 2025</td>
            <td><strong>Datesheet for UG-PG Examinations</strong></td>
            <td><a href="https://shahsatnamjigirlscollege.com/wp-content/uploads/2025/05/ilovepdf_merged-2.pdf" target="_blank" class="text-primary fw-bold text-decoration-none">View PDF <i class="fa fa-external-link small"></i></a></td>
          </tr>
          <tr>
            <td class="text-muted">Current</td>
            <td><strong>Syllabus as per NEP Guidelines</strong></td>
            <td><a href="https://www.cdlu.ac.in/index.php/examinations-tl/42.html" target="_blank" class="text-primary fw-bold text-decoration-none">View Details <i class="fa fa-external-link small"></i></a></td>
          </tr>
          <tr>
            <td class="text-muted">March 2025</td>
            <td><strong>UG & PG Admission Notice 2025-26</strong></td>
            <td><a href="https://shahsatnamjigirlscollege.com/wp-content/uploads/2025/03/Guidelines-UG-PG-Admission.pdf" target="_blank" class="text-primary fw-bold text-decoration-none">Download <i class="fa fa-download small"></i></a></td>
          </tr>
          <tr>
            <td class="text-muted">April 2025</td>
            <td><strong>A Rich Bonanza of Courses - Undergraduate and Postgraduate Levels</strong></td>
            <td><a href="https://shahsatnamjigirlscollege.com/wp-content/uploads/2025/04/A-Rich-Bonanza-of-Courses-at-Undergraduate-and-Postgraduate-Levels.pdf" target="_blank" class="text-primary fw-bold text-decoration-none">View Brochure <i class="fa fa-external-link small"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="section-subtitle mt-5">Latest Campus Updates</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-6">
        <div class="info-card p-3 d-flex justify-content-between align-items-center">
          <div>
            <span class="small text-muted d-block mb-1">April 20, 2026</span>
            <h6 class="mb-0 fw-bold">Farewell Party 2026</h6>
          </div>
          <a href="https://shahsatnamjigirlscollege.com/2026/04/20/farewell-party-2026/" target="_blank" class="btn btn-sm btn-outline-primary rounded-pill">Read More</a>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-card p-3 d-flex justify-content-between align-items-center">
          <div>
            <span class="small text-muted d-block mb-1">April 20, 2026</span>
            <h6 class="mb-0 fw-bold">Library Week Awareness Program</h6>
          </div>
          <a href="https://shahsatnamjigirlscollege.com/2026/04/20/library-week-awareness-program/" target="_blank" class="btn btn-sm btn-outline-primary rounded-pill">Read More</a>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-card p-3 d-flex justify-content-between align-items-center">
          <div>
            <span class="small text-muted d-block mb-1">April 20, 2026</span>
            <h6 class="mb-0 fw-bold">Career Counseling Session</h6>
          </div>
          <a href="https://shahsatnamjigirlscollege.com/2026/04/20/career-counseling-session-on-teaching-opportunities/" target="_blank" class="btn btn-sm btn-outline-primary rounded-pill">Read More</a>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-card p-3 d-flex justify-content-between align-items-center">
          <div>
            <span class="small text-muted d-block mb-1">April 20, 2026</span>
            <h6 class="mb-0 fw-bold">Submission of Project Work</h6>
          </div>
          <a href="https://shahsatnamjigirlscollege.com/2026/04/20/submission-of-project-work/" target="_blank" class="btn btn-sm btn-outline-primary rounded-pill">Read More</a>
        </div>
      </div>
    </div>

  </div>
</div>
